'use client';

import { c as _c } from "react/compiler-runtime";
import type { LinkProps as NextLinkProps } from 'next/link';
import { trackClick } from '@sola/tracking/components/datalayer.tsx';
import { getTextFromReactNode } from '@sola/utils/react.ts';
import { useRouter } from '../../utils/hooks/useRouter.ts';
export type LinkProps = NextLinkProps & React.PropsWithChildren & {
  id?: string;
  className?: string;
  isDisabled?: boolean;
  title?: string;
  download?: boolean;
  type?: 'button' | 'submit' | 'reset';
  target?: string;
  rel?: string;
};
export const Link: React.FC<LinkProps> = t0 => {
  const $ = _c(7);
  let isDisabled;
  let props;
  if ($[0] !== t0) {
    ({
      isDisabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isDisabled;
    $[2] = props;
  } else {
    isDisabled = $[1];
    props = $[2];
  }
  const {
    RouterComponent
  } = useRouter();
  let t1;
  if ($[3] !== RouterComponent || $[4] !== isDisabled || $[5] !== props) {
    t1 = !RouterComponent || isDisabled ? <a {...props as React.ComponentProps<'a'>} {...isDisabled && {
      "aria-disabled": true,
      role: "link",
      href: undefined
    }} /> : <RouterComponent {...props} onClick={e => {
      trackClick(props.title || getTextFromReactNode(props.children) || "Unknown", props.href?.toString(), props.className, props.id);
      if (props.onClick) {
        props.onClick(e);
      }
    }} />;
    $[3] = RouterComponent;
    $[4] = isDisabled;
    $[5] = props;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};